import { Box, VStack } from "@chakra-ui/react";
import WaitList from "../../components/SettlementLists/WaitList";
import CpsSettlementCampaignList from "../../components/SettlementLists/CpsSettlementCampaignList";

export default function CompleteTab({
  list,
  cpsList,
  onCpsPayCommissions,
  cpsPayBusyId,
}) {
  const combined = [
    ...(list ?? []).map((item) => ({
      type: "cpuc",
      key: `cpuc-${item.campaignId}`,
      item,
    })),
    ...(cpsList ?? []).map((item) => ({
      type: "cps",
      key: `cps-${item.campaignId}`,
      item,
    })),
  ];
  const hasData = combined.length > 0;

  return (
    <VStack spacing="4" w="100%">
      {hasData ? (
        <>
          {combined.map(({ type, key, item }) => (
            <Box w="100%" key={key}>
              {type === "cps" ? (
                <CpsSettlementCampaignList
                  item={item}
                  onPayCommissions={onCpsPayCommissions}
                  payCommissionsBusyId={cpsPayBusyId}
                />
              ) : (
                <WaitList item={item} />
              )}
            </Box>
          ))}
        </>
      ) : (
        <div>검색 결과가 없습니다.</div>
      )}
    </VStack>
  );
}
